<div class="panel constrain">
	<div class="heading">Regimes</div>
	<div class="content nopad">
		<table class="log openborders paneled regimes">
			<thead>
				<tr>
					<th># Acq</th>
					<th>Regime</th>
					<th>{{ evaluateHeader }}</th>
					<ng-container *ngTemplateOutlet="headerCells"></ng-container>
				</tr>
			</thead>
			@for (regime of regimes ?? []; track regime) {
				<tbody>
					<tr>
						<td>{{regime.count}}</td>
						<td>{{regime.name}}</td>
						<td class="center">
							<input type="checkbox" [(ngModel)]="regime.evaluate" (ngModelChange)="evaluateChange.emit()">
						</td>
						<ng-container *ngTemplateOutlet="rowCells; context: { $implicit: regime }"></ng-container>
					</tr>
				</tbody>
			}
			@if (regimes === undefined) {
				<tbody>
					<tr>
						<td [attr.colspan]="3 + extraColumns" class="loading-status">
							<div class="logo-spin"></div>
							Loading regimes...
						</td>
					</tr>
				</tbody>
			}
			@if (regimes?.length === 0) {
				<tbody>
					<tr>
						<td [attr.colspan]="3 + extraColumns" class="loading-status">No regime data found</td>
					</tr>
				</tbody>
			}
		</table>
	</div>
</div>
